import { useState, useEffect } from "react";
import { Box, Text, RadioButtonGroup } from "grommet";
import { updateStateHandler } from "../Utils/Utils";
  
const RadioWithText = (props) => {
    // console.log('In RadioWithText props obj:', props);
    const [value, setValue] = useState(props.initValue);

    useEffect(() => {
        // initialization of all values at page opening
        if(props.initValue){
            props.getOptions().map((option) => { 
                if(option.index === props.initValue){
                    setValue(option.value);
                }
                return option.value;
            });   
        } else {
            setValue(props.initValue);
        }
    }, []);

    const getPrevGrade = () => {
        // There are several options for each RadioButton group. 
        // For example, PruningOptions have 'Long/Cane', 'Half long' and some other options;
        // FertilityOptions have 'Very fertile', 'Fertile', 'Not fertile'.
        // For each option from the collection there is an index and a grade.
        let prGrade = {        
            index: 0,
            grade: 0};

        props.getOptions().map((option) => {
            if (option.index === props.initValue){
                prGrade.grade = option.grade;
                prGrade.index = option.index;
            }           
        });
        return prGrade;
    };

    const updateValue = (newValue) => {
        if (newValue === value) {
            setValue(null);
            const prevGrade = getPrevGrade();
            if (props.updateGrade) {
                props.updateGrade(prevGrade, { grade: 0, index: null });
            }

            updateStateHandler(props.stateHandler, props.fieldName, null);
        } else { 
            // The new value is different from previous
            setValue(newValue);        
            // console.log("props.initValue > ", props.initValue);
            // console.log("value > ", newValue);
            props.getOptions().map((option) => {
                if (option.value === newValue){
                    updateStateHandler(props.stateHandler, props.fieldName, option.index)
                    const prevGrade = getPrevGrade();
                    if(props.updateGrade){
                        props.updateGrade(prevGrade, option);
                    }
             
                }
                return option.value;
            });
        }
    };

    //  console.log("In radio props.disable > ", props.disable);
    //  console.log("In radio props.disable.disable > ", props.disable.disable);


    const style = {
        outline: 'none',  boxShadow: 'none',
        color: props.radioColor,
        fontWeight: "bolder", 
        fontSize: "16px",
        padding: props.padding === undefined ? "10px 5px" : props.padding,      
    };

    return (
        <Box alignContent="between" pad="small" margin="xxsmall" >
            <Text  alignSelf="start" color="brand" size="18px">
                {props.text}
            </Text>
            <RadioButtonGroup
                style={style}
                direction={props.direction === undefined ? "row" : props.direction}
                disabled={props.disable}
                // readOnly={props.disable}
                name={props.fieldName}
                gap = {props.direction === undefined ? "medium" : "xxsmall"}
                options={props.getOptions()}
                value={value}
                onClick={(event) => {
                    updateValue(event.target.value);
                }}
            />
        </Box>
    );
};

export default RadioWithText;
